import * as React from 'react';
import {ApolloProvider} from 'react-apollo';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';
import {Router} from 'react-router-dom';

import {ApolloProvider as ReactHooksApolloProvider} from '@apollo/react-hooks';

import {nutApolloClient} from '../../../../../apollo-client';
import {appHistory} from '../../../../../history';
import {store} from '../../../../../store';

import {DromoProductImporter} from './dromo-product-importer';

export function mountDromoProductImporter() {
    const dromoProductImporterContainer = document.querySelector('#product-importer-react-mount');

    if (dromoProductImporterContainer) {
        ReactDOM.render(
            <Provider store={store}>
                <ApolloProvider client={nutApolloClient}>
                    <ReactHooksApolloProvider client={nutApolloClient}>
                        <Router history={appHistory}>
                            <DromoProductImporter />
                        </Router>
                    </ReactHooksApolloProvider>
                </ApolloProvider>
            </Provider>,
            dromoProductImporterContainer
        );
    }
}
